var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossinline = function SvgCrossinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    fillRule: "evenodd",
    d: "M.249 1.132a.557.557 0 0 1 .787 0l13.387 13.366a.555.555 0 1 1-.788.787L.25 1.918a.555.555 0 0 1 0-.786",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    fillRule: "evenodd",
    d: "M.249 15.285a.555.555 0 0 1 0-.787L13.635 1.132a.557.557 0 0 1 .788.786L1.036 15.285a.557.557 0 0 1-.787 0",
    clipRule: "evenodd"
  })));
};
export default SvgCrossinline;